import moment from 'moment';
let searchDate = moment().startOf().format('YYYYMMDD');
export default {
	searchParams: SEARCH_PARAMS(),
	partList: [],
	pagingInfo: PAGING_INFO(),
	opCdList: [] //OP코드 콤보박스 리스트
};

function SEARCH_PARAMS() {
	return {
		stdDt: searchDate,
		partNo: '',
		partNoInput: '',
		opCd: '',
		pwaYn: ''
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

export { SEARCH_PARAMS, PAGING_INFO };
